import axios from 'axios'

import { resolveTourUseIpp } from '../components/views/image_viewer/components/ViewerPane/components/tourUseIpp'

import { Project } from './types'

const API_BASE = process.env.REACT_APP_NEXTERA_API

const fetchProject = async (projectId: string) => {
  try {
    const res = await axios.get(`${API_BASE}/project/${projectId}`)
    const response = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrProjects==>>', err)
  }
}

const updateProject = async (
  projectId: string,
  projectData: Partial<Project>,
) => {
  try {
    const res = await axios.patch(
      `${API_BASE}/project/${projectId}`,
      projectData,
    )
    const response = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errUpdateProject==>>', err)
  }
}

const fetchFloors = async (projectId: string) => {
  try {
    const floorsUrl = `${API_BASE}/project/${projectId}/floors`
    const res = await axios.get(floorsUrl)
    const response = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrFloors==>>', err)
  }
}

const fetchManageFloors = async (projectId: string) => {
  try {
    const floorsUrl = `${API_BASE}/project/${projectId}/floors/manage_floors`
    const res = await axios.get(floorsUrl)
    const response = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrManageFloors==>>', err)
  }
}

const fetchFloor = async (projectId: string, floorId: string) => {
  try {
    // When A/B ?tourUseIpp=1 (same parse as resolveTourUseIpp) is on the page,
    // ask the API for NexLoc/Progress inches_per_pixel. Default serialize only
    // emits floor_plan_scale. useFloorImages keys react-query on this flag so
    // toggling the query refetches (full reload still works too).
    let floorUrl = `${API_BASE}/project/${projectId}/floor/${floorId}`
    if (typeof window !== 'undefined') {
      const search = window.location.search || ''
      const params = new URLSearchParams(search)
      const wantUntrusted =
        params.get('include_untrusted_tour_metrology') === '1' ||
        resolveTourUseIpp(search)
      if (wantUntrusted) {
        floorUrl += '?include_untrusted_tour_metrology=1'
      }
    }
    const res = await axios.get(floorUrl)
    const response = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrFloors==>>', err)
  }
}

const fetchManageFloor = async (projectId: string, floorId: string) => {
  try {
    const floorUrl = `${API_BASE}/project/${projectId}/floor/${floorId}/manage_floor`
    const res = await axios.get(floorUrl)
    const response = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrManageFloor==>>', err)
  }
}

const fetchImage = async (imageUrl: string): Promise<Blob> => {
  try {
    // Use fetch instead of Axios which was problematic with certain browser environments
    const res = await fetch(imageUrl)
    if (!res.ok) {
      throw new Error(`Image fetch failed: ${res.status} ${res.statusText}`)
    }
    const blob = await res.blob()
    if (!blob || blob.size === 0) {
      throw new Error('Image fetch returned an empty blob')
    }
    return blob
  } catch (err) {
    // eslint-disable-next-line no-console -- Keep visibility in console
    console.log('errrImage==>>', err)
    throw err
  }
}

const fetchPoints = async (
  projectId: string,
  floorId: string,
  activeOnly = false,
) => {
  try {
    const res = await axios.get(
      `${API_BASE}/project/${projectId}/floor/${floorId}/viewpoints/points${activeOnly ? '?is_active=true' : ''}`,
    )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper response type
    const response: any = await res.data
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrPoints==>>', err)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper params type
const fetchPointImages = async (
  projectId: string,
  floorId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper params value type
  params?: Record<string, any>,
) => {
  try {
    const res = await axios.get(
      `${API_BASE}/project/${projectId}/floor/${floorId}/viewpoints/images`,
      {
        params: params,
      },
    )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper response type
    const response: any = await res.data
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper item type
    const resp = response.data.map((item: any, i: number) => {
      item.taken_on = item.taken_on + `T12:00:00.${i % 1000}`
      return item
    })
    return resp
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrPointImages==>>', err)
  }
}

const fetchPointImage = async (
  projectId: string,
  floorId: string,
  viewpointImage: string,
) => {
  try {
    const res = await axios.get(
      `${API_BASE}/project/${projectId}/floor/${floorId}/viewpoints/image/${viewpointImage}`,
    )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper response type
    const response: any = await res.data
    response.data.taken_on = response.data.taken_on + 'T12:00:00.000'
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.log('errrPointImage==>>', err)
  }
}

export {
  fetchProject,
  updateProject,
  fetchFloors,
  fetchManageFloors,
  fetchImage,
  fetchPointImages,
  fetchPoints,
  fetchFloor,
  fetchManageFloor,
  fetchPointImage,
}
